var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#8754ba}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4405",
    "data-name": "Group 4405",
    transform: "translate(-885 -2163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(893.003 2170.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4387",
    "data-name": "Group 4387",
    transform: "translate(-.003 -.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    className: "cls-3",
    d: "M222.791 154.7a.393.393 0 0 0-.393.393v7.431a.393.393 0 1 0 .786 0V155.1a.393.393 0 0 0-.393-.4zm0 0",
    transform: "translate(-213.654 -148.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    className: "cls-3",
    d: "M104.791 154.7a.393.393 0 0 0-.393.393v7.431a.393.393 0 1 0 .786 0V155.1a.393.393 0 0 0-.393-.4zm0 0",
    transform: "translate(-100.293 -148.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    className: "cls-3",
    d: "M1.113 5v9.687a2.169 2.169 0 0 0 .577 1.5 1.936 1.936 0 0 0 1.4.607h7.439a1.936 1.936 0 0 0 1.4-.607 2.169 2.169 0 0 0 .577-1.5V5a1.5 1.5 0 0 0-.385-2.954h-2.004v-.494A1.544 1.544 0 0 0 8.56 0H5.069a1.544 1.544 0 0 0-1.557 1.552v.491H1.5A1.5 1.5 0 0 0 1.113 5zm9.421 11H3.095a1.245 1.245 0 0 1-1.2-1.317V5.031h9.829v9.652A1.245 1.245 0 0 1 10.534 16zM4.3 1.552a.757.757 0 0 1 .769-.767H8.56a.757.757 0 0 1 .771.767v.491H4.3zM1.5 2.829h10.63a.708.708 0 1 1 0 1.415H1.5a.708.708 0 1 1 0-1.415zm0 0",
    transform: "translate(.003 .002)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    className: "cls-3",
    d: "M163.791 154.7a.393.393 0 0 0-.393.393v7.431a.393.393 0 1 0 .786 0V155.1a.393.393 0 0 0-.393-.4zm0 0",
    transform: "translate(-156.974 -148.62)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.0b23d721.svg";
export { ForwardRef as ReactComponent };